import { render, staticRenderFns } from "./CozeChat.vue?vue&type=template&id=5b1d109f&scoped=true"
import script from "./CozeChat.vue?vue&type=script&lang=js"
export * from "./CozeChat.vue?vue&type=script&lang=js"
import style0 from "./CozeChat.vue?vue&type=style&index=0&id=5b1d109f&prod&scoped=true&lang=css"
import style1 from "./CozeChat.vue?vue&type=style&index=1&id=5b1d109f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d109f",
  null
  
)

export default component.exports